<div class="w-full mb-6" *ngIf="configuration">
  <lib-buy-now
    [labels]="'lib.buyNow' | translate"
    [productName]="configuration.name"
    [productImgUrl]="productImgUrl"
    [quantity]="quantity"
    [isVirtual]="isVirtual"
    [totalPrice]="totalPrice"
    [deliveryPrice]="isVirtual ? undefined : deliveryPrice"
    [loading]="loading"
    [relayPointsList]="relayPointsList"
    [wilayasList]="wilayasList"
    [wilayaCities]="wilayaCities"
    [storesList]="storesList"
    (back)="goBack()"
    (confirmOrder)="onConfirmOrder($event)"
    (wilayaSelected)="onWilayaSelected($event)"
    (deliveryDetails)="onDeliveryDetails($event)"
  ></lib-buy-now>
</div>
